import { createContext, useContext, useState } from "react";
import { getJsonValue, isBoolTrue, } from "../../common/fusion-ui/utils/ReactUtils";
import { Keys } from "../config/AppConfig";
import { isCurrUserRoleAdmin } from "../utils/AppUtils";

const ConfigContext = createContext();
const TAG = "ConfigProvider";
const ConfigProvider = ({ children }) => {
        const [configData, setConfigData] = useState({
            //default initialization
            [Keys.config_showHelp]: true,
            [Keys.config_showShare]: isCurrUserRoleAdmin(),
            [Keys.config_showSearch]: true,
            [Keys.config_showRecentPanel]: true,
            [Keys.config_showCalendar]: true,
            [Keys.config_showHomeRightPanels]: true,
            [Keys.config_showNavBar]: true,
            [Keys.config_showFooter]: true,
            [Keys.config_ShowTabBar]: true,
            [Keys.config_navbarCurrPage]: "",
            [Keys.tracker_currPageTag]: "",
            [Keys.tracker_currPageModule]: "",
            [Keys.config_TabBarTab]: -1,
        });
        // useEffect(() => {
        //     setConfigData(prevState => ({
        //         ...prevState,
        //         // [Keys.tracker_currPageTag]: '',
        //         // [Keys.tracker_currPageModule]: ''
        //     }));
        // }, []);

        const value = { configData, getConfig, updateConfig, isConfigTrue };
        return ( < ConfigContext.Provider value = { value } > { children } < /ConfigContext.Provider>);

            /**
             * Update a specific configuration value.
             * @param {string} configKey The key to update in the configuration data.
             * @param {any} [value] Value to update config-key with.
             */
            function updateConfigx(configKey, value) {
                setConfigData((prevState) => ({...prevState, [configKey]: value }));
                if (configKey == Keys.config_navbarCurrPage) {
                    setConfigData((prevState) => ({
                        ...prevState,
                        [Keys.config_TabBarTab]: -1,
                    }));
                } else if (configKey == Keys.config_TabBarTab) {
                    setConfigData((prevState) => ({
                        ...prevState,
                        [Keys.config_navbarCurrPage]: "",
                    }));
                }
            }

            /**
             * Update one or multiple configuration values.
             *
             * @example
             *  //Store key-value
             *  updateConfig(Keys.config_showHelp, !getConfig(Keys.config_showHelp));
             *
             *  //Store-Object: Updating multiple values at once
             *  updateConfig({
             *        [Keys.config_ShowTabBar]: true,
             *        [Keys.config_TabBarTab]: Modules.Home
             *  });
             *
             * @param {string|object} keyOrObject The key to update or an object with multiple key-value pairs.
             * @param {any|null} [value=null] Value to update config-key with (only used if keyOrObject is a string).
             */
            function updateConfig(keyOrObject, value) {
                // printLog(TAG, 'updateConfig.keyOrObject:', keyOrObject, 'value:', value);

                // setConfigData(prevState => {
                //     // Handle type-based key-data
                //     const newState = typeof keyOrObject === 'object'
                //         ? {...prevState, ...keyOrObject}
                //         : {...prevState, [keyOrObject]: value};
                //
                //     // Handle special cases
                //     if (Keys.config_navbarCurrPage in newState || keyOrObject === Keys.config_navbarCurrPage) {
                //         newState[Keys.config_TabBarTab] = -1;
                //     }
                //     if (Keys.config_TabBarTab in newState || keyOrObject === Keys.config_TabBarTab) {
                //         newState[Keys.config_navbarCurrPage] = '';
                //     }
                //
                //     return newState;
                // });

                if (typeof keyOrObject === "object") {
                    setConfigData((prevState) => {
                        const newState = {...prevState, ...keyOrObject };
                        // Handle special cases for navbar and tabbar
                        if (Keys.config_navbarCurrPage in keyOrObject) {
                            newState[Keys.config_TabBarTab] = -1;
                        }
                        if (Keys.config_TabBarTab in keyOrObject) {
                            newState[Keys.config_navbarCurrPage] = "";
                        }
                        return newState;
                    });
                } else {
                    setConfigData((prevState) => {
                        const newState = {...prevState, [keyOrObject]: value };
                        // Handle special cases for navbar and tabbar
                        if (keyOrObject === Keys.config_navbarCurrPage) {
                            newState[Keys.config_TabBarTab] = -1;
                        } else if (keyOrObject === Keys.config_TabBarTab) {
                            newState[Keys.config_navbarCurrPage] = "";
                        }
                        return newState;
                    });
                }

                function handleSingleUpdation(key, value) {}
            }

            /**
             * Retrieves a specific configuration value.
             * @param {string} configKey The key of the configuration value to retrieve.
             * @param {any?} defValue The default value to return if the key is not found.
             * @returns {any} The value associated with the configKey, or the provided defValue.
             */
            function getConfig(configKey, defValue) {
                return getJsonValue(configData, configKey, defValue);
            }

            /**
             * Checks if value a config-key is true or false.
             * @param {string} configKey The config-key to check if it's value is true or false.
             * @returns {Boolean} Returns true if value of config-key is true, otherwise false.
             */
            function isConfigTrue(configKey) {
                return isBoolTrue(getConfig(configKey), true, true);
            }
        };

        /**
         * Custom hook to access & updated the configurable values.
         *
         * For more information, see {@link getConfig} and {@link updateConfig}
         *
         * @returns {{ configData: Object, getConfig(configKey: String, defValue: any|null): function: any,
         * updateConfig(configKey: String|Object, value: any|null): function,
         * isConfigTrue(configKey: String): function: boolean }}
         *
         * @example
         * import React from 'react';
         * import { useConfig } from './ConfigProvider';
         *
         * const YourComponent = () => {
         *   const { configData, getConfig, updateConfig, isConfigTrue } = useConfig();
         *
         *   return (
         *     <div>
         *       <button onClick={()=>{
         *          //Store key-value
         *          updateConfig(Keys.config_showHelp, !getConfig(Keys.config_showHelp));
         *
         *          //Store-Object: Updating multiple values at once
         *          updateConfig({
         *                [Keys.config_ShowTabBar]: true,
         *                [Keys.config_TabBarTab]: Modules.Home
         *          });
         *       }}>
         *           {getConfig(Keys.config_showHelp) ? 'Hide' : 'Show'} Help
         *       </button>
         *     </div>
         *   );
         * };
         *
         * export default YourComponent;
         */
        const useConfig = () => {
            return useContext(ConfigContext);
        };
        export { ConfigProvider, useConfig };